import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'zuck',
  name: 'Zuck',
  palette: {
    primary: '#244180',
    accent: '#1963FF',
    neutral: '#DFE3EE',
  },
  light1: {
    'action-primary': '#5572aa',
    'action-primary-hovered': '#355291',
    'action-primary-pressed': '#213d7c',
    'action-primary-subdued': '#f6f7fa',
    'action-primary-subdued-hovered': '#f1f3f8',
    'action-primary-subdued-pressed': '#e1e7f1',
    'action-primary-disabled': '#f4f7ff',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f4f7ff',
    'action-neutral-pressed': '#eff3fd',
    'action-neutral-subdued': '#eff3fd',
    'action-neutral-subdued-hovered': '#e2e6f1',
    'action-neutral-subdued-pressed': '#d0d4df',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#eff3fd',
    background: '#eff3fd',
    'background-hovered': '#e2e6f1',
    'background-pressed': '#d0d4df',
    'background-selected': '#d0d4df',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#9ea2aa',
    content: '#060607',
    'content-subdued': '#525459',
    'content-muted': '#707279',
    'content-hovered': '#171719',
    'content-pressed': '#525459',
    'content-disabled': '#9ea2aa',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#001c75',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#0d245a',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f4f7ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#060607',
    'content-on-background-subdued': '#525459',
    'content-on-background-hovered': '#171719',
    'content-on-background-pressed': '#525459',
    'content-on-background-disabled': '#9ea2aa',
    interactive: '#355291',
    'interactive-hovered': '#213d7c',
    'interactive-pressed': '#0d245a',
    'interactive-disabled': '#f4f7ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f4f7ff',
    topbar: '#3B5998',
    'topbar-subdued': '#344e86',
    'content-on-topbar': '#f5f5ff',
    'line-on-topbar': '#d0d4df',
    'line-on-topbar-pressed': '#707279',
    link: '#0044d2',
    'link-hovered': '#85a5f4',
    'link-pressed': '#7292f9',
    line: '#d0d4df',
    'line-subdued': '#e2e6f1',
    'line-hovered': '#9ea2aa',
    'line-pressed': '#707279',
    'line-selected': '#525459',
    'line-disabled': '#e2e6f1',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0044d2',
    'line-highlight-subdued': '#b6d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#355291',
    skeleton: '#e2e6f1',
    surface: '#FFFFFF',
    'surface-subdued': '#eff3fd',
    'surface-hovered': '#eff3fd',
    'surface-subdued-hovered': '#e2e6f1',
    'surface-pressed': '#e2e6f1',
    'surface-disabled': '#f4f7ff',
    'surface-selected': '#f6f7fa',
    'surface-selected-hovered': '#f1f3f8',
    'surface-selected-pressed': '#e1e7f1',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d5e8ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#ebf4ff',
    'surface-highlight-subdued-pressed': '#d5e8ff',
    'surface-neutral': '#e2e6f1',
    'surface-neutral-subdued': '#f4f7ff',
    'surface-inverse': '#171719',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#5572aa',
    'action-primary-hovered': '#355291',
    'action-primary-pressed': '#213d7c',
    'action-primary-subdued': '#f6f7fa',
    'action-primary-subdued-hovered': '#f1f3f8',
    'action-primary-subdued-pressed': '#e1e7f1',
    'action-primary-disabled': '#f4f7ff',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f4f7ff',
    'action-neutral-pressed': '#eff3fd',
    'action-neutral-subdued': '#eff3fd',
    'action-neutral-subdued-hovered': '#e2e6f1',
    'action-neutral-subdued-pressed': '#d0d4df',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#eff3fd',
    background: '#FFFFFF',
    'background-hovered': '#eff3fd',
    'background-pressed': '#e2e6f1',
    'background-selected': '#e2e6f1',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#9ea2aa',
    content: '#060607',
    'content-subdued': '#525459',
    'content-muted': '#707279',
    'content-hovered': '#171719',
    'content-pressed': '#525459',
    'content-disabled': '#9ea2aa',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#001c75',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#0d245a',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f4f7ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#060607',
    'content-on-background-subdued': '#525459',
    'content-on-background-hovered': '#171719',
    'content-on-background-pressed': '#525459',
    'content-on-background-disabled': '#9ea2aa',
    interactive: '#355291',
    'interactive-hovered': '#213d7c',
    'interactive-pressed': '#0d245a',
    'interactive-disabled': '#f4f7ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f4f7ff',
    topbar: '#FFFFFF',
    'topbar-subdued': '#eff3fd',
    'content-on-topbar': '#060607',
    'line-on-topbar': '#d0d4df',
    'line-on-topbar-pressed': '#707279',
    link: '#0044d2',
    'link-hovered': '#0031ab',
    'link-pressed': '#001c75',
    line: '#d0d4df',
    'line-subdued': '#e2e6f1',
    'line-hovered': '#9ea2aa',
    'line-pressed': '#707279',
    'line-selected': '#525459',
    'line-disabled': '#e2e6f1',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0044d2',
    'line-highlight-subdued': '#b6d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#355291',
    skeleton: '#e2e6f1',
    surface: '#FFFFFF',
    'surface-subdued': '#eff3fd',
    'surface-hovered': '#eff3fd',
    'surface-subdued-hovered': '#e2e6f1',
    'surface-pressed': '#e2e6f1',
    'surface-disabled': '#f4f7ff',
    'surface-selected': '#f6f7fa',
    'surface-selected-hovered': '#f1f3f8',
    'surface-selected-pressed': '#e1e7f1',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d5e8ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#ebf4ff',
    'surface-highlight-subdued-pressed': '#d5e8ff',
    'surface-neutral': '#e2e6f1',
    'surface-neutral-subdued': '#f4f7ff',
    'surface-inverse': '#171719',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#5572aa',
    'action-primary-hovered': '#355291',
    'action-primary-pressed': '#213d7c',
    'action-primary-subdued': '#f6f7fa',
    'action-primary-subdued-hovered': '#f1f3f8',
    'action-primary-subdued-pressed': '#e1e7f1',
    'action-primary-disabled': '#f4f7ff',
    'action-neutral': '#eff3fd',
    'action-neutral-hovered': '#e2e6f1',
    'action-neutral-pressed': '#d0d4df',
    'action-neutral-subdued': '#e2e6f1',
    'action-neutral-subdued-hovered': '#d0d4df',
    'action-neutral-subdued-pressed': '#d0d4df',
    'action-neutral-disabled': '#f4f7ff',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#eff3fd',
    background: '#FFFFFF',
    'background-hovered': '#eff3fd',
    'background-pressed': '#e2e6f1',
    'background-selected': '#e2e6f1',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#9ea2aa',
    content: '#060607',
    'content-subdued': '#525459',
    'content-muted': '#707279',
    'content-hovered': '#171719',
    'content-pressed': '#525459',
    'content-disabled': '#9ea2aa',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#001c75',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#0d245a',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f4f7ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#060607',
    'content-on-background-subdued': '#525459',
    'content-on-background-hovered': '#171719',
    'content-on-background-pressed': '#525459',
    'content-on-background-disabled': '#9ea2aa',
    interactive: '#355291',
    'interactive-hovered': '#213d7c',
    'interactive-pressed': '#0d245a',
    'interactive-disabled': '#f4f7ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f4f7ff',
    topbar: '#eff3fd',
    'topbar-subdued': '#e2e6f1',
    'content-on-topbar': '#060607',
    'line-on-topbar': '#d0d4df',
    'line-on-topbar-pressed': '#707279',
    link: '#0044d2',
    'link-hovered': '#0031ab',
    'link-pressed': '#001c75',
    line: '#d0d4df',
    'line-subdued': '#e2e6f1',
    'line-hovered': '#9ea2aa',
    'line-pressed': '#707279',
    'line-selected': '#525459',
    'line-disabled': '#e2e6f1',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0044d2',
    'line-highlight-subdued': '#b6d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#355291',
    skeleton: '#e2e6f1',
    surface: '#eff3fd',
    'surface-subdued': '#e2e6f1',
    'surface-hovered': '#e2e6f1',
    'surface-subdued-hovered': '#d0d4df',
    'surface-pressed': '#d0d4df',
    'surface-disabled': '#f4f7ff',
    'surface-selected': '#f6f7fa',
    'surface-selected-hovered': '#f1f3f8',
    'surface-selected-pressed': '#e1e7f1',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d5e8ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#ebf4ff',
    'surface-highlight-subdued-pressed': '#d5e8ff',
    'surface-neutral': '#e2e6f1',
    'surface-neutral-subdued': '#f4f7ff',
    'surface-inverse': '#171719',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#5e729a',
    'action-primary-hovered': '#3d537f',
    'action-primary-pressed': '#2a3f6a',
    'action-primary-subdued': '#2a3f6a',
    'action-primary-subdued-hovered': '#3d537f',
    'action-primary-subdued-pressed': '#3d537f',
    'action-primary-disabled': '#3f4043',
    'action-neutral': '#28282a',
    'action-neutral-hovered': '#3f4043',
    'action-neutral-pressed': '#525458',
    'action-neutral-subdued': '#28282a',
    'action-neutral-subdued-hovered': '#3f4043',
    'action-neutral-subdued-pressed': '#525458',
    'action-neutral-disabled': '#3f4043',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#3f4043',
    background: '#171719',
    'background-hovered': '#28282a80',
    'background-pressed': '#28282a',
    'background-selected': '#28282a',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#9fa2a8',
    content: '#f4f7ff',
    'content-subdued': '#d1d4dc',
    'content-muted': '#9fa2a8',
    'content-hovered': '#f0f3fa',
    'content-pressed': '#d1d4dc',
    'content-disabled': '#707277',
    'content-on-positive': '#cceed6',
    'content-on-attention': '#ffe1c3',
    'content-on-highlight': '#d9e7ff',
    'content-on-negative': '#ffdfda',
    'content-on-negative-hovered': '#ffc6bd',
    'content-on-negative-pressed': '#ffc6bd',
    'content-primary': '#f1f3f7',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171719',
    'content-on-destructive': '#f4f7ff',
    'content-on-interactive': '#f4f7ff',
    'content-on-background': '#f4f7ff',
    'content-on-background-subdued': '#d1d4dc',
    'content-on-background-hovered': '#f0f3fa',
    'content-on-background-pressed': '#d1d4dc',
    'content-on-background-disabled': '#707277',
    interactive: '#5e729a',
    'interactive-hovered': '#3d537f',
    'interactive-pressed': '#2a3f6a',
    'interactive-disabled': '#171719',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171719',
    topbar: '#28282a',
    'topbar-subdued': '#3f4043',
    'content-on-topbar': '#f4f7ff',
    'line-on-topbar': '#3f4043',
    'line-on-topbar-pressed': '#707277',
    link: '#bdd5ff',
    'link-hovered': '#73a1f9',
    'link-pressed': '#3b6ed5',
    line: '#3f4043',
    'line-subdued': '#3f4043',
    'line-hovered': '#525458',
    'line-pressed': '#707277',
    'line-selected': '#525458',
    'line-disabled': '#3f4043',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#04143c',
    'line-highlight-subdued': '#04143c',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#5e729a',
    skeleton: '#3f4043',
    surface: '#28282a',
    'surface-subdued': '#3f4043',
    'surface-hovered': '#3f4043',
    'surface-subdued-hovered': '#525458',
    'surface-pressed': '#525458',
    'surface-disabled': '#3f4043',
    'surface-selected': '#2a3f6a',
    'surface-selected-hovered': '#3d537f',
    'surface-selected-pressed': '#3d537f',
    'surface-attention': '#5b38144d',
    'surface-attention-subdued': '#3c220a4d',
    'surface-negative': '#7128214d',
    'surface-negative-subdued': '#4a17124d',
    'surface-negative-subdued-hovered': '#2f0b084d',
    'surface-negative-subdued-pressed': '#2f0b084d',
    'surface-positive': '#17492d4d',
    'surface-positive-subdued': '#0b2e1a4d',
    'surface-highlight': '#163b894d',
    'surface-highlight-subdued': '#0a245d4d',
    'surface-highlight-subdued-hovered': '#04143c4d',
    'surface-highlight-subdued-pressed': '#04143c4d',
    'surface-neutral': '#525458',
    'surface-neutral-subdued': '#3f4043',
    'surface-inverse': '#f4f7ff',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#5e729a',
    'action-primary-hovered': '#3d537f',
    'action-primary-pressed': '#2a3f6a',
    'action-primary-subdued': '#2a3f6a',
    'action-primary-subdued-hovered': '#3d537f',
    'action-primary-subdued-pressed': '#3d537f',
    'action-primary-disabled': '#3f4043',
    'action-neutral': '#171719',
    'action-neutral-hovered': '#28282a',
    'action-neutral-pressed': '#3f4043',
    'action-neutral-subdued': '#28282a',
    'action-neutral-subdued-hovered': '#3f4043',
    'action-neutral-subdued-pressed': '#3f4043',
    'action-neutral-disabled': '#28282a',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#3f4043',
    background: '#28282a',
    'background-hovered': '#3f404380',
    'background-pressed': '#3f4043',
    'background-selected': '#3f4043',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#9fa2a8',
    content: '#f4f7ff',
    'content-subdued': '#d1d4dc',
    'content-muted': '#9fa2a8',
    'content-hovered': '#f0f3fa',
    'content-pressed': '#d1d4dc',
    'content-disabled': '#707277',
    'content-on-positive': '#cceed6',
    'content-on-attention': '#ffe1c3',
    'content-on-highlight': '#d9e7ff',
    'content-on-negative': '#ffdfda',
    'content-on-negative-hovered': '#ffc6bd',
    'content-on-negative-pressed': '#ffc6bd',
    'content-primary': '#f1f3f7',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171719',
    'content-on-destructive': '#f4f7ff',
    'content-on-interactive': '#f4f7ff',
    'content-on-background': '#f4f7ff',
    'content-on-background-subdued': '#d1d4dc',
    'content-on-background-hovered': '#f0f3fa',
    'content-on-background-pressed': '#d1d4dc',
    'content-on-background-disabled': '#707277',
    interactive: '#5e729a',
    'interactive-hovered': '#3d537f',
    'interactive-pressed': '#2a3f6a',
    'interactive-disabled': '#171719',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171719',
    topbar: '#171719',
    'topbar-subdued': '#28282a',
    'content-on-topbar': '#f4f7ff',
    'line-on-topbar': '#3f4043',
    'line-on-topbar-pressed': '#707277',
    link: '#bdd5ff',
    'link-hovered': '#73a1f9',
    'link-pressed': '#3b6ed5',
    line: '#3f4043',
    'line-subdued': '#3f4043',
    'line-hovered': '#525458',
    'line-pressed': '#707277',
    'line-selected': '#525458',
    'line-disabled': '#3f4043',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#04143c',
    'line-highlight-subdued': '#04143c',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#5e729a',
    skeleton: '#3f4043',
    surface: '#171719',
    'surface-subdued': '#28282a',
    'surface-hovered': '#28282a',
    'surface-subdued-hovered': '#3f4043',
    'surface-pressed': '#3f4043',
    'surface-disabled': '#28282a',
    'surface-selected': '#2a3f6a',
    'surface-selected-hovered': '#3d537f',
    'surface-selected-pressed': '#3d537f',
    'surface-attention': '#5b38144d',
    'surface-attention-subdued': '#3c220a4d',
    'surface-negative': '#7128214d',
    'surface-negative-subdued': '#4a17124d',
    'surface-negative-subdued-hovered': '#2f0b084d',
    'surface-negative-subdued-pressed': '#2f0b084d',
    'surface-positive': '#17492d4d',
    'surface-positive-subdued': '#0b2e1a4d',
    'surface-highlight': '#163b894d',
    'surface-highlight-subdued': '#0a245d4d',
    'surface-highlight-subdued-hovered': '#04143c4d',
    'surface-highlight-subdued-pressed': '#04143c4d',
    'surface-neutral': '#525458',
    'surface-neutral-subdued': '#3f4043',
    'surface-inverse': '#f4f7ff',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
